<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div
            v-if="error"
            class="alert alert-dismissible alert-danger">{{ error }}</div>
          <div
            v-if="deletedItem"
            class="alert alert-dismissible alert-success">{{ deletedItem.sqlScript }} {{$t('notifications.deleted')}}</div>
        </b-col>
      </b-row>
<!--      <b-row>-->
<!--        <b-col>-->
<!--          <h5>{{$t('views.sqlscriptexecuted.list.title')}}</h5>-->
<!--        </b-col>-->
<!--      </b-row>-->
      <b-row>
        <b-col>
          <b-card>
            <template v-if="isLoading">
              <Loader></Loader>
            </template>
            <template v-else>
              <div v-if="items.length > 0">
                <table class="table table-striped table-hover">
                  <thead>
                  <tr>
                    <th>{{$t('views.sqlscriptexecuted.list.title')}}</th>
                    <th>{{$t('views.sqlscriptexecuted.list.scriptExecuted')}} :</th>
                  </tr>
                  </thead>
                  <tr  v-for="item in items"
                        :key="item['@id']">
                  <td>
                    <b-row>
                      <b-col>
                          <router-link :to="{name: 'SqlScriptExecutedShow', params: { id: item['@id'] }}">
                            <span v-if="item.applicationType">{{item.applicationType.title}} - {{item.sqlScript}}</span>
                          </router-link>
                      </b-col>
                    </b-row>
                  </td>
                    <td>
                      <b-row>
                        <b-col>
                          <span> {{$moment(item.createdAt).format(DATETIMEFORMATTYPE)}}</span>
                      </b-col>
                    </b-row>
                  </td>
                  </tr>
                </table>
              </div>
              <div v-else>
                {{$t('notifications.noData')}}
              </div>
              <div v-if="view">
                <pagination
                  :view="view"
                  @getPage="getPage($event)"
                ></pagination>
              </div>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { DATETIMEFORMATTYPE } from '@/config/datetimeFormatType'
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'

export default {
  components: {
    Loader,
    Pagination
  },
  data () {
    return {
      DATETIMEFORMATTYPE
    }
  },
  computed: mapGetters({
    deletedItem: 'sqlscriptexecuted/del/deleted',
    error: 'sqlscriptexecuted/list/error',
    items: 'sqlscriptexecuted/list/items',
    isLoading: 'sqlscriptexecuted/list/isLoading',
    view: 'sqlscriptexecuted/list/view'
  }),

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'sqlscriptexecuted/list/default'
  })
}
</script>
